var AddToCartType = /* @__PURE__ */ ((AddToCartType2) => {
  AddToCartType2["ADDTOCART"] = "addToCart";
  AddToCartType2["BUYNOW"] = "buy_now";
  AddToCartType2["INSTALLMENT"] = "installment";
  return AddToCartType2;
})(AddToCartType || {});

export { AddToCartType };
